import { COPY } from "data/content";
import { ICopy, supportedLanguages } from "data/content.types";
import { create } from "zustand";

export interface GlobalStoreType {
  language: string;
  setLanguage: (state: string) => void;

  copy: ICopy;
  setCopy: (state: ICopy) => void;

  isLoading: boolean;
  setIsLoading: (state: boolean) => void;

  showUI: boolean;
  setShowUI: (state: boolean) => void;

  showEventOverlay: boolean;
  setShowEventOverlay: (state: boolean) => void;
  
  showPreSaleOverlay: boolean;
  setShowPreSaleOverlay: (state: boolean) => void;
  
  showGalleryOverlay: boolean;
  setShowGalleryOverlay: (state: boolean) => void;

  loadedPercentage: number;
  setLoadedPercentage: (state: number) => void;
  
  isPreEvent: boolean;
  setIsPreEvent: (state: boolean) => void;
  
  isEventLive: boolean;
  setIsEventLive: (state: boolean) => void;
  
  hasAllFeatures: boolean;
  setHasAllFeatures: (state: boolean) => void;

  isContentLoaded: boolean;
  setIsContentLoaded: (state: boolean) => void;

  sceneMounted: boolean;
  setSceneMounted: (state: boolean) => void;

  isPreVenda: boolean;
  setIsPreVenda: (state: boolean) => void;

  isCTA: boolean;
  setIsCTA: (state: boolean) => void;

  isCountdown: boolean;
  setIsCountdown: (state: boolean) => void;
}

const useGlobalStore = create<GlobalStoreType>(
  (
    set: (partial: (store: GlobalStoreType) => Partial<GlobalStoreType>) => void
  ) => {
    return {
      language: supportedLanguages.es,
      setLanguage: (state) => {
        set(() => ({
          language: state,
        }));
      },
      copy: COPY[supportedLanguages.es],
      setCopy: (state) => {
        set(() => ({
          copy: state,
        }));
      },
      isLoading: true,
      setIsLoading: (state) => {
        set(() => ({
          isLoading: state,
        }));
      },
      showUI: false,
      setShowUI: (state) => {
        set(() => ({
          showUI: state,
        }));
      },
      showEventOverlay: false,
      setShowEventOverlay: (state) => {
        set(() => ({
          showEventOverlay: state,
        }));
      },
      showPreSaleOverlay: false,
      setShowPreSaleOverlay: (state) => {
        set(() => ({
          showPreSaleOverlay: state,
        }));
      },
      showGalleryOverlay: false,
      setShowGalleryOverlay: (state) => {
        set(() => ({
          showGalleryOverlay: state,
        }));
      },
      loadedPercentage: 0,
      setLoadedPercentage: (state) => {
        set(() => ({
          loadedPercentage: state,
        }));
      },
      isPreEvent: false,
      setIsPreEvent: (state) => {
        set(() => ({
          isPreEvent: state,
        }));
      },
      isEventLive: false,
      setIsEventLive: (state) => {
        set(() => ({
          isEventLive: state,
        }));
      },
      hasAllFeatures: false,
      setHasAllFeatures: (state) => {
        set(() => ({
          hasAllFeatures: state,
        }));
      },
      isContentLoaded: false,
      setIsContentLoaded: (state) => {
        set(() => ({
          isContentLoaded: state,
        }));
      },
      sceneMounted: false,
      setSceneMounted: (state) => {
        set(() => ({
          sceneMounted: state,
        }));
      },
      isPreVenda: false,
      setIsPreVenda: (state) => {
        set(() => ({
          isPreVenda: state,
        }));
      },
      isCTA: false,
      setIsCTA: (state) => {
        set(() => ({
          isCTA: state,
        }));
      },

      isCountdown: false,
      setIsCountdown: (state) => {
        set(() => ({
          isCountdown: state,
        }));
      },
    };
  }
);

export default useGlobalStore;
